import { ComponentType } from '@angular/cdk/portal';
import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DictionaryService } from 'src/app/services/dictionary.service';
import { UserNotificationService } from '../notification/userNotifications.service';
import { ContactDialogComponent } from './contactDialog/contactDialog.component';
import { ContributeResponseComponent } from './contribute-response/contribute-response.component';
import { HelpDialogComponent } from './helpDialog/helpDialog.component';

@Injectable()
export class DialogService {
  private lastParentElement: HTMLElement;
  private readonly customBackdrop: HTMLElement;

  constructor(
    public dialog: MatDialog,
    public notificationService: UserNotificationService,
    public dictionaryService: DictionaryService,
  ) {
    this.customBackdrop = document.createElement('div');
    this.customBackdrop.classList.add('dialog-custom-backdrop');
  }

  private openDialog(
    dialogId: string,
     
    contentComponent: ComponentType<any>,
    configIn?: Record<string, unknown>,
    parentElement?: HTMLElement,
  ): void {
    // don't open if already open
    if (this.dialog.getDialogById(dialogId) == null) {
      this.lastParentElement = parentElement;

      const config = {
        ...defaultConfig,
        id: dialogId,
        hasBackdrop: this.lastParentElement == null,
        ...configIn,
      };
      if (this.dialog.openDialogs.length === 0) {
        this.addCustomBackdrop();
      }
      const dialogRef = this.dialog.open(contentComponent, config);

      dialogRef
        .afterClosed()
        .toPromise()
        .then(() => this.tryRemoveCustomBackdrop());
    }
  }

  public openHelpDialog(parentElement?: HTMLElement): void {
    this.openDialog('help', HelpDialogComponent, {}, parentElement);
  }

  public openContactDialog(parentElement?: HTMLElement): void {
    this.openDialog('contact', ContactDialogComponent, {}, parentElement);
  }
  public openContributeResponse(responsePromise: Promise<void>, parentElement?: HTMLElement): void {
    this.openDialog(
      'contributeResponse',
      ContributeResponseComponent,
      {
        data: {
          obsDetailsPromise: responsePromise,
        },
      },
      parentElement,
    );
  }

  private addCustomBackdrop(): void {
    if (this.lastParentElement != null) {
      this.lastParentElement.classList.add('dialog-custom-backdrop-wrapper');
      this.lastParentElement.appendChild(this.customBackdrop);
    }
  }
  private tryRemoveCustomBackdrop(): void {
    if (this.dialog.openDialogs.length === 0) {
      const parent = this.customBackdrop.parentElement;
      if (parent != null) {
        parent.classList.remove('dialog-custom-backdrop-wrapper');
        parent.removeChild(this.customBackdrop);
      }
    }
  }
}

const defaultConfig = {
  minHeight: 150,
  panelClass: 'ev-dialog',
};
